import { call, put, takeLatest } from "redux-saga/effects"
import { callApi } from "sagas/Api"
import {
  PUT_OVERALL_AGREEMENTS,
  setSuccess,
  storeUserAgreementsStatus,
} from "actions"
import { putAgreements } from "apis/Agreements"
import { handlingPutApiError } from "./CommonErrorHandling"

const USER_AGREEMENT_STATUS_TRUE = "1"

export function* handlePutUserAgreementsStatus() {
  yield takeLatest(PUT_OVERALL_AGREEMENTS, execPutUserAgreementsStatus)
}

export function* execPutUserAgreementsStatus() {
  const { payload, error } = yield call(callApi, putAgreements)
  if (payload && !error) {
    yield put(
      storeUserAgreementsStatus({
        userAgreementsStatus: USER_AGREEMENT_STATUS_TRUE,
      })
    )
    yield put(setSuccess(payload))
  } else {
    yield call(handlingPutApiError, error)
  }
}
